/* global THREE */
import aframe from "aframe";
import { bindEvent } from "aframe-event-decorators";

const rand = () => (Math.random() - 0.5) * 2;

const v1 = new THREE.Vector3();
/*
const v2 = new THREE.Vector3();

const m1 = new THREE.Matrix4();
const e1 = new THREE.Euler();
*/
let timeWarpFactor = 1;

aframe.registerComponent("missile-spawn-zone", {
  init: function () {
    this._debugPlane = new THREE.Mesh(
      new THREE.PlaneGeometry(2, 2, 4),
      new THREE.MeshBasicMaterial({ color: "blue", side: THREE.DoubleSide })
    );
    this._debugPlane.rotation.x = Math.PI / 2;
    this._debugPlane.visible = false;
    this.el.object3D.add(this._debugPlane);
    this._timer = this.data.interval;

    window.spawn = () => this.spawnMissileVolley(1);
  },
  play: function () {
    this._gameState = document.querySelector("[game-state]").components[
      "game-state"
    ];
  },
  spawnMissileVolley: function (n, config) {
    for (let i = 0; i < n; i++) {
      this.spawnMissile(config);
    }
  },
  spawnSmartMissile: function (config) {
    const target = this._gameState.getRandomSiloOrCity();
    if (target === undefined) {
      return; // No player targets, so dont spawn a missile.
    }

    const start = v1.set(
      rand() * this.el.object3D.scale.x,
      this.el.object3D.position.y,
      rand() * this.el.object3D.scale.z
    );

    const missileConfig = Object.assign(
      {
        timeWarpFactor
      },
      config
    );
    this.el.sceneEl.systems.missile.spawnSmartMissileAndTarget(
      missileConfig,
      start,
      target
    );
  },
  spawnMissile: function (config) {
    const target = this._gameState.getRandomSiloOrCity();
    if (target === undefined) {
      return; // No player targets, so dont spawn a missile.
    }

    const start = v1
      .set(
        rand() * this.el.object3D.scale.x,
        0,
        rand() * this.el.object3D.scale.z
      )
      .add(this.el.object3D.position);

    const missileConfig = Object.assign(
      {
        speed: 0.03,
        color: "red",
        isPlayer: false,
        timeWarpFactor
      },
      config
    );
    this.el.sceneEl.systems.missile.spawnAndTarget(
      missileConfig,
      start,
      target
    );
  },
  inspectorenabled: bindEvent({ target: "a-scene" }, function () {
    this._debugPlane.visible = true;
  }),
  inspectordisabled: bindEvent({ target: "a-scene" }, function () {
    this._debugPlane.visible = false;
  }),
  gamestatechanged: bindEvent({ target: "[game-state]" }, function (evt) {
    const newState = evt.detail;
    if (newState === "Playing") {
      timeWarpFactor = 1;
      this.el.setAttribute("paused", false);
    } else {
      this.el.setAttribute("paused", true);
    }
  }),
  startTimeWarp: bindEvent({ target: '[game-state]' }, function (evt) {
    timeWarpFactor = evt.detail.factor;
  }),
  endTimeWarp: bindEvent({ target: '[game-state]' }, function (evt) {
    timeWarpFactor = 1;
  })
});
